import { Grid, Paper, Button, Typography, Table, TableHead, TableRow, TableCell } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import MigaPan from '../../app/orussystem/component/MigaPan';
import ListPolls from '../compoment/ListPolls';
import { editPolls } from '../domain/EncuestasApi';
import { PollPanelStyle } from './PollPanelStyle';
import ModalPolls from '../compoment/modalFormPolls';
import 'react-notifications-component/dist/theme.css'
import { Store } from 'react-notifications-component';
import { useParams } from 'react-router-dom';
import { getpoll, performCreateNewPoll } from '../domain/EncuestasApi';
import { panelUsersAuthStyle } from '../../centraldevida/users_auth/panelUsersAuthStyle';
import theme from '../../app/config/themaConfig';




export const PollPanel = (props) => {
  const classes = PollPanelStyle();


  const [listPoll, setListPoll] = useState([]);
  const [isLoadList, setIsLoadList] = useState(false);
  const [openModal, setOpenModal] = useState(false)
  const [dataEdit, setdataEdit] = useState({})
  const [isEdit, setisEdit] = useState(false)
  const [isReload, setIsreload] = useState(false)
  const [nameBascula] = useState("")
  const clases = panelUsersAuthStyle()

  let { id } = useParams();
  let idPoll = id === ":id" || id === "" ? 0 : id;

  const setAsyncData = (data) => {
    setdataEdit(data);
    return Promise.resolve(); // No es necesario crear una nueva promesa aquí
  };
  const handledEditPoll = async (data) => {
    setisEdit(true)
    setAsyncData(data).then((data) => setOpenModal(true))
  }

  const handledNewPoll = () => {
    setisEdit(false)
    setOpenModal(true)
  }

  //Metodo para crear Polls
  const createNewPoll = (request) => {
    performCreateNewPoll(request)
      .then((response) => {
        if (response.codigo === "0000") {

          Store.addNotification({
            title: "Creando Exitosamente!",
            message: `la encuesta ${request.name} fue creada con exito!`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });

          setIsreload(true);
          setOpenModal(false);
        } else {

          Store.addNotification({
            title: "Error en la Creación",
            message: response.mensaje,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });

          setIsreload(true)
          setOpenModal(false)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  //Metodo para editar polls
  const editPoll = (request) => {

    editPolls(request)
      .then((response) => {
        if (response.codigo === "0000") {

          Store.addNotification({
            title: "Creando Exitosamente!",
            message: `la encuesta ${request.name} fue editada con exito!`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              onScreen: true
            }
          });

          setIsreload(true)
          setOpenModal(false)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadList(true);
      const lista = await getpoll();
      setListPoll(lista.respuesta);
      setIsLoadList(false);
    };

    fetchData(); // Llama a la función asíncrona aquí
  }, [isReload]);
  const primaryColor = theme.palette.primary.main;


  return (
    <>
      {openModal && <ModalPolls
        setopenMondal={setOpenModal}
        isOpen={openModal}
        dataEdit={dataEdit}
        setdataEdit={setdataEdit}
        isEdit={isEdit}
        createNewPoll={createNewPoll}
        editPoll={editPoll}
      />}

      {idPoll === 0 && <Grid item xs={12} >
        <br></br>
        <br></br>

        <MigaPan namePage="Encuestas" to="/" >
          Home
        </MigaPan>
      </Grid>}

      {idPoll !== 0 && <Grid item xs={12} >
        <br></br>
        <br></br>
        <MigaPan
          namePage={`Encuestas ${nameBascula}`}
          to="/"
        >
          Home
        </MigaPan>
      </Grid>}
      <Paper className={classes.paper} style={{ width: '100%' }} >

        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} className={classes.searchContainer} >
              <Typography style={{ fontSize: '25px', fontWeight: 'bold', marginTop: '1%', marginBottom: '2%', marginRight: '75%' }} color='primary'>Encuestas </Typography>


              <Button
                variant="contained"
                color="primary"
                onClick={handledNewPoll}
                style={{ borderRadius: '10px' }}

              >
                Nueva Encuesta
              </Button>
            </Grid>
            <Grid item xs={12}>
              {/* Encabezados de la tabla */}


              <Table>
                <TableHead color='primary'>
                  <TableRow color='primary'>
                    <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '20%', color: primaryColor }}>Id</TableCell>
                    <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '25%', color: primaryColor }}>Nombre</TableCell>
                    <TableCell className={clases.TableCell} style={{ width: '35%', paddingLeft: '5%', color: primaryColor }}>Descripción</TableCell>
                    <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '35%', color: primaryColor }}>Acciones</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Grid>
            <Grid item xs={12}>
              <ListPolls
                rows={listPoll}
                isLoadUser={isLoadList}
                handledEditPoll={handledEditPoll}
                idPoll={idPoll}
                primaryColor={primaryColor}
              />
            </Grid>
          </Grid>

        </Grid>
      </Paper>
    </>


  )



}